import ThisModule from "./BookingWizard";

export default ThisModule;
